import Log from '../core/Log';

export const log = new Log('one-lni');



// WEBPACK FOOTER //
// ./source/framework/instance/frameworkLog.js